export enum UserRole {
  ITAdmin = 3,
  AOAdmin = 9,
  OfqualEventNotificationsAdmin = 13,
  AOEventNotificationsAdmin = 14,
  CCEAEventNotificationsAdmin = 15,
}

export const EnRoles = [
  UserRole.ITAdmin,
  UserRole.OfqualEventNotificationsAdmin,
  UserRole.AOAdmin,
  UserRole.AOEventNotificationsAdmin,
  UserRole.CCEAEventNotificationsAdmin
];